import './styles.scss'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { ButtonTag } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import { getValues } from './utils'
import { lang } from 'utils/helpers'

const RedirectButton = ({ action }) => {
  const { push } = useHistory()
  const { text, pathname } = getValues(action)

  if (!text) return null

  return (
    <ButtonTag
      className='massive-actions-redirect-btn'
      icon={
        <figure className='massive-actions-redirect-btn__icon'>
          <img src={getStaticImage('/icons/orange-brand/external-link-primary.svg')} alt='External link' />
        </figure>
      }
      value={lang(text)}
      onClick={() => push(pathname)}
    />
  )
}

export default RedirectButton